import { useEffect, useState } from "react";
import { getBrandKit, saveBrandKit } from "./api.js";

// One shared copy of the brand kit for every colour picker on the page:
// fetched once, updated in place, and pushed to subscribers on change.
let kit = null;
let loading = null;
const listeners = new Set();

function publish(next) {
  kit = next;
  listeners.forEach((fn) => fn(kit));
}

function load() {
  if (!loading) {
    loading = getBrandKit()
      .then(publish)
      .catch(() => publish({ name: "Brand", colors: [], fonts: [] }));
  }
  return loading;
}

export function useBrandKit() {
  const [value, setValue] = useState(kit);
  useEffect(() => {
    listeners.add(setValue);
    if (!kit) load();
    return () => listeners.delete(setValue);
  }, []);
  return value;
}

export async function updateBrandKit(patch) {
  const next = { ...(kit || { name: "Brand", colors: [], fonts: [] }), ...patch };
  publish(next);
  try {
    publish(await saveBrandKit(next));
  } catch {
    /* keep the optimistic copy; it is retried on the next change */
  }
}

const RECENT_KEY = "recent_colors";

export function getRecentColors() {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
  } catch {
    return [];
  }
}

export function pushRecentColor(hex) {
  try {
    const next = [hex, ...getRecentColors().filter((c) => c !== hex)].slice(0, 12);
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    /* storage blocked: recents just don't persist */
  }
}
